// Modern Angular 20 - No lodash or moment dependencies
import { dateValueFormatter } from '../utils/format-date-cell';
import { recurrenceLabel } from '../utils/date-recurrence';
import { entityPathFor } from '../utils/entity-route';

export let colCriticalDateNum = {
                                colId: 'criticalDateNum',
                                headerName: 'Date ID',
                                field: 'criticalDateNum',
                                width: 100
                              };

export let colImportantDate = {
                                colId: 'importantDate',
                                headerName: 'Important Date',
                                field: 'eventDate',
                                width: 120,
                                valueFormatter: dateValueFormatter
                              };

export let colReminderDate =  {
                                colId: 'reminderDate',
                                headerName: 'Reminder Date',
                                field: 'reminderDate',
                                width: 120,
                                valueFormatter: dateValueFormatter
                              };

export let colAssignedTo =  {
                                colId: 'assignedTo',
                                headerName: 'Assigned To',
                                field: 'assignedTo',
                                width: 150,
                                valueFormatter: assignedToFormatter
                              };

export let colAssignedBy =  {
                                colId: 'assignedBy',
                                headerName: 'Assigned By',
                                field: 'assignedBy',
                                width: 125,
                                valueFormatter: assignedByFormatter
                              };

export let colOwner =  {
                                colId: 'owner',
                                headerName: 'Owner',
                                field: 'owner',
                                width: 100
                        };


export let colDateType = {
                            colId: 'dateType',
                            headerName: 'Date Type',
                            field: 'type',
                            width: 100
                          };


export let colDescription =  {
                                      colId: 'description',
                                      headerName: 'Description',
                                      field: 'description',
                                      width: 200
                                    };

export let colInternalRecipients =  {
                                      colId: 'internalRecipients',
                                      headerName: 'Internal Recipients',
                                      field: 'internalRecipients',
                                      width: 100
                                    };

export let colSourceRecord =  {
                                colId: 'sourceRecord',
                                headerName: 'Source Record Number',
                                field: 'entityNumber',
                                width: 100
                              };

export let colEntityType =  {
                              colId: 'entityType',
                              headerName: 'Source Type',
                              field: 'entityType',
                              width: 100
                            };

export let colEntityName =  {
                              colId: 'entityName',
                              headerName: 'Source Name',
                              field: 'entityName',
                              width: 100
                            };

export let colEntityId =  {
                              colId: 'entityId',
                              headerName: 'Source ID',
                              field: 'entityId',
                              width: 100
                            };


export let colEntityLink =  {
                              colId: 'entityLink',
                              headerName: 'Link To Source',
                              field: 'entityType',
                              width: 100,
                              cellRenderer: (params: any) => {
                                  const data = params.data;
                                  let entityKey = data?.entityNum || data?.entityId;
                                  if (!data?.entityType || !entityKey) return '';

                                  const href = entityPathFor(data.entityType, entityKey);
                                  if (!href) return '';
                                  const a = document.createElement('a');
                                  a.innerText = data.entityName || data.entityType;
                                  a.href = href;
                                  a.target = '_blank';
                                  // Prevent click from reaching AgGrid
                                  a.addEventListener('click', event => { event.stopPropagation() });
                                  return a;
                              }
                            };
                            

export let colRequiredAction = {colId: 'requiredAction', headerName: 'Required Action', field: 'requiredAction', width: 150 };
export let colActionSummary = {colId: 'actionSummary', headerName: 'Action Summary/Notes', field: 'actionSummary', width: 200 };
export let colName = {colId: 'name', headerName: 'Important Date Name', field: 'name', width: 100 };
export let colActionCompleted = {colId: 'actionCompleted',
                                  headerName: 'Action Completed',
                                  field: 'actionCompleted',
                                  width: 100,
                                  valueFormatter: yesNoFormatter };


export let colReminderStatus = {
  colId: 'reminderSent',
  headerName: 'Reminder Status',
  field: 'reminderSent',
  width: 140,
  valueGetter: (params: any) => {
    if (!params.data) return '';
    if (!params.data.emailNotificationEnabled) return 'Off';
    if (!params.data.reminderDate) return 'No reminder set';
    if (params.data.reminderSent) {
      const sentDate = params.data.reminderSentDate
        ? new Date(params.data.reminderSentDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
        : '';
      return sentDate ? `Sent ${sentDate}` : 'Sent';
    }
    const reminderDate = new Date(params.data.reminderDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (reminderDate <= today) return 'Pending send';
    return 'Scheduled';
  }
};

/**
 * Whether the date repeats, and how often — 'Annually', 'Quarterly', '' when it
 * does not. Reads the label helper rather than the raw unit/interval so a
 * non-preset value ('Every 5 months') still renders honestly.
 */
export let colRecurrence = {
  colId: 'recurrence',
  headerName: 'Repeats',
  field: 'recurrence',
  width: 120,
  valueGetter: (params: any) => recurrenceLabel(params.data?.recurrence)
};

export let allColumns = [
  colImportantDate,
  colReminderDate,
  colReminderStatus,
  colRecurrence,
  colDateType,
  colAssignedTo,
  colAssignedBy,
  colDescription,
  colOwner,
  colEntityName,
  colEntityId,
  colEntityLink,
  colEntityType,
  colName,
  colRequiredAction,
  colActionSummary,
  colActionCompleted
]



export let columnSelectList = [
  {
    value: colImportantDate,
    viewValue: colImportantDate.headerName
  },
  {
    value: colRecurrence,
    viewValue: colRecurrence.headerName
  },
  {
    value: colReminderDate,
    viewValue: colReminderDate.headerName
  },
  {
    value: colDateType,
    viewValue: colDateType.headerName
  },
  {
    value: colAssignedTo,
    viewValue: colAssignedTo.headerName
  },
  {
    value: colAssignedBy,
    viewValue: colAssignedBy.headerName
  },
  {
    value: colDescription,
    viewValue: colDescription.headerName
  },
  {
    value: colOwner,
    viewValue: colOwner.headerName
  },
  {
    value: colEntityName,
    viewValue: colEntityName.headerName
  },
  {
    value: colEntityId,
    viewValue: colEntityId.headerName
  },
  {
    value: colEntityLink,
    viewValue: colEntityLink.headerName
  },
  {
    value: colEntityType,
    viewValue: colEntityType.headerName
  },
  {
    value: colName,
    viewValue: colName.headerName
  },
  {
    value: colRequiredAction,
    viewValue: colRequiredAction.headerName
  },
  {
    value: colActionSummary,
    viewValue: colActionSummary.headerName
  },
  {
    value: colActionCompleted,
    viewValue: colActionCompleted.headerName
  }
]



/**
 * Formats the assignedTo array (user emails) as semicolon-delimited list
 * Note: This is a simple formatter. For name hydration, use a valueGetter in the component
 */
function assignedToFormatter(params: any): string {
  const userEmails = params.value;

  if (!userEmails || !Array.isArray(userEmails) || userEmails.length === 0) {
    return '';
  }

  // Simple email display - component can override with valueGetter for name hydration
  return userEmails.join('; ');
}

/**
 * Formats the assignedBy field (single user email)
 * Note: This is a simple formatter. For name hydration, use a valueGetter in the component
 */
function assignedByFormatter(params: any): string {
  return params.value || '';
}

/**
 * Checks if a date has expired and returns styling
 */
function dateExpired(params: any): any {
  if (!params.value) {
    return null;
  }

  try {
    const dateToEvaluate = new Date(params.value);
    const today = new Date();
    const diffTime = today.getTime() - dateToEvaluate.getTime();
    const daysPast = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (daysPast >= 0) {
      return { color: 'black', backgroundColor: 'red' };
    } else if (daysPast >= 180) {
      return { color: 'black', backgroundColor: 'yellow' };
    }
  } catch (error) {
    return null;
  }
}

/**
 * Formats boolean actionCompleted as Yes/No
 */
function yesNoFormatter(params: any): string {
  if (params.data && params.data.actionCompleted) {
    return 'Yes';
  } else {
    return 'No';
  }
}
